import { clipperInitials } from '@/lib/cpm/clipperInitials';
import { cn } from '@/lib/utils';

const SIZE_CLASS = {
  md: 'w-9 h-9 text-xs',
  sm: 'w-7 h-7 text-[10px]',
} as const;
const PHOTO_CLASS = 'rounded-full object-cover border-2 border-primary/40 flex-shrink-0';
const FALLBACK_CLASS = 'rounded-full bg-primary/20 border-2 border-primary/40 text-primary font-bold flex items-center justify-center flex-shrink-0';
const ANONYMOUS_CLASS = 'rounded-full bg-muted border-2 border-primary/20 flex-shrink-0 blur-sm';

type ClipperLeaderboardAvatarProps = {
  name?: string | null;
  avatarUrl?: string | null;
  anonymous?: boolean;
  anonymousTestId?: string;
  size?: keyof typeof SIZE_CLASS;
};

export function ClipperLeaderboardAvatar({
  name,
  avatarUrl,
  anonymous = false,
  anonymousTestId,
  size = 'md',
}: ClipperLeaderboardAvatarProps) {
  if (anonymous) {
    return (
      <div
        data-testid={anonymousTestId}
        aria-hidden="true"
        className={cn(ANONYMOUS_CLASS, SIZE_CLASS[size])}
      />
    );
  }

  const displayName = name ?? '';
  if (avatarUrl) {
    return (
      <img
        src={avatarUrl}
        alt={displayName}
        className={cn(PHOTO_CLASS, SIZE_CLASS[size])}
      />
    );
  }

  return (
    <div
      aria-hidden="true"
      data-testid="clipper-leaderboard-avatar-fallback"
      className={cn(FALLBACK_CLASS, SIZE_CLASS[size])}
    >
      {clipperInitials(displayName)}
    </div>
  );
}
